import {
  LOADING_BEGIN,
  LOADING_SUCCESS
} from './types'

const initialState = {
  loading: false
}

const getters = {
  isLoading: state => state.loading
}

const actions = {
  begin_loading ({ commit }) {
    commit(LOADING_BEGIN)
  },
  end_loading ({ commit }) {
    commit(LOADING_SUCCESS)
  }
}

const mutations = {
  [LOADING_BEGIN] (state) {
    state.loading = true
  },
  [LOADING_SUCCESS] (state) {
    state.loading = false
  }
}

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/loading.js